import {API_URL} from '@shared/services/api.service';
import ApiService from '@shared/services/api.service';

const EmailRebaselineService = {
  submitRebaselineRequest(code) {
    return ApiService.post('/email_rebaseline/' + code, null);
  },
  fetchJobStatusFromJobUrl(url) {
    // Note the intentional URL manipulation here. The "job status URL" provided is relative to the API server root
    // (without the /api) so we have to convert it to a full URL manually.
    // If we don't convert then ApiService just appends so the /api repeats twice which is incorrect.
    const fullUrl = new URL(url, API_URL).href;
    return ApiService.get(fullUrl);
  }
};
export default EmailRebaselineService;
